import { gql } from "@apollo/client";

export const MODIFY_MEMBER_ROLE_MUTATION = gql`
  mutation ModifyMemberRoleMutation($modifyMemberRoleData: ModifyMemberData!) {
    modifyMemberRole(data: $modifyMemberRoleData)
  }
`;
